import script from "./StrategicAlignment.vue?vue&type=script&setup=true&lang=js"
export * from "./StrategicAlignment.vue?vue&type=script&setup=true&lang=js"

import "./StrategicAlignment.vue?vue&type=style&index=0&id=9897bc4a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9897bc4a"]])

export default __exports__